import styled from "styled-components";
import { Link } from "react-router-dom";

/* ─── Layout (공통 — AdminLogin과 동일 구조) ──────────────────── */

export const Page = styled.div`
  display: flex;
  min-height: 100vh;
  background-color: #f4f6f8;
  align-items: stretch;
`;

export const LeftPanel = styled.div`
  width: 420px;
  flex-shrink: 0;
  background-color: #0c0e0c;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 52px 48px;
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: -100px;
    right: -100px;
    width: 320px;
    height: 320px;
    background: radial-gradient(circle, rgba(31, 188, 112, 0.2) 0%, transparent 70%);
    pointer-events: none;
  }

  &::after {
    content: "";
    position: absolute;
    bottom: -60px;
    left: -60px;
    width: 240px;
    height: 240px;
    background: radial-gradient(circle, rgba(31, 188, 112, 0.1) 0%, transparent 70%);
    pointer-events: none;
  }
`;

export const LeftTop = styled.div``;

export const LogoImg = styled.img`
  height: 32px;
  width: auto;
  filter: brightness(0) invert(1);
  margin-bottom: 48px;
`;

export const LeftTitle = styled.h1`
  font-size: 28px;
  font-weight: 900;
  color: #f8fdf9;
  line-height: 1.3;
  letter-spacing: -0.02em;
  margin-bottom: 16px;
  word-break: keep-all;

  span {
    color: #1fbc70;
  }
`;

export const LeftDesc = styled.p`
  font-size: 14px;
  color: rgba(255, 255, 255, 0.4);
  line-height: 1.8;
  word-break: keep-all;
`;

export const LeftBottom = styled.div`
  padding: 28px;
  background-color: rgba(31, 188, 112, 0.06);
  border: 1px solid rgba(31, 188, 112, 0.15);
  border-radius: 16px;
`;

export const LeftNotice = styled.p`
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
  line-height: 1.8;
  word-break: keep-all;

  strong {
    color: #1fbc70;
    font-weight: 600;
  }
`;

/* ─── Right panel ────────────────────────────────────────────── */

export const RightPanel = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px 40px;
  overflow-y: auto;
`;

export const FormCard = styled.div`
  width: 100%;
  max-width: 480px;
  background-color: #ffffff;
  border-radius: 24px;
  padding: 48px 44px;
  box-shadow: 0 4px 40px rgba(0, 0, 0, 0.08);
`;

export const FormTitle = styled.h2`
  font-size: 24px;
  font-weight: 800;
  color: #111;
  letter-spacing: -0.02em;
  margin-bottom: 6px;
`;

export const FormSubtitle = styled.p`
  font-size: 14px;
  color: #999;
  margin-bottom: 36px;
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 32px;
`;

export const Field = styled.div``;

export const FieldLabel = styled.label`
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #555;
  margin-bottom: 8px;
  letter-spacing: 0.02em;
`;

export const Input = styled.input<{ hasError?: boolean }>`
  width: 100%;
  height: 50px;
  padding: 0 16px;
  border: 1.5px solid ${({ hasError }) => (hasError ? "#fc324a" : "#e8e8e8")};
  border-radius: 12px;
  font-size: 15px;
  color: #111;
  background-color: #fafafa;
  transition: border-color 0.15s, background-color 0.15s;

  &::placeholder {
    color: #bbb;
  }

  &:focus {
    border-color: ${({ hasError }) => (hasError ? "#fc324a" : "#1fbc70")};
    background-color: #fff;
    outline: none;
  }
`;

export const Select = styled.select<{ hasError?: boolean }>`
  width: 100%;
  height: 50px;
  padding: 0 16px;
  border: 1.5px solid ${({ hasError }) => (hasError ? "#fc324a" : "#e8e8e8")};
  border-radius: 12px;
  font-size: 15px;
  color: #111;
  background-color: #fafafa;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%23999' stroke-width='1.5' fill='none' stroke-linecap='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 16px center;
  cursor: pointer;
  transition: border-color 0.15s, background-color 0.15s;

  &:focus {
    border-color: ${({ hasError }) => (hasError ? "#fc324a" : "#1fbc70")};
    background-color: #fff;
    outline: none;
  }

  option[value=""] {
    color: #bbb;
  }
`;

export const FieldError = styled.p`
  font-size: 12px;
  color: #fc324a;
  margin-top: 6px;
`;

export const SubmitButton = styled.button`
  width: 100%;
  height: 52px;
  background-color: #1fbc70;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  border-radius: 12px;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s, transform 0.1s;
  margin-bottom: 16px;

  &:hover {
    background-color: #18a860;
  }

  &:active {
    transform: scale(0.98);
    background-color: #159150;
  }

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
    transform: none;
  }
`;

export const BackLink = styled(Link)`
  display: block;
  text-align: center;
  font-size: 13px;
  color: #bbb;
  text-decoration: none;

  &:hover {
    color: #888;
  }
`;

/* ─── Success 상태 ───────────────────────────────────────────── */

export const SuccessCard = styled.div`
  width: 100%;
  max-width: 480px;
  background-color: #ffffff;
  border-radius: 24px;
  padding: 60px 44px;
  box-shadow: 0 4px 40px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const SuccessIcon = styled.div`
  width: 72px;
  height: 72px;
  background-color: #f0fdf7;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  margin-bottom: 24px;
`;

export const SuccessTitle = styled.h2`
  font-size: 22px;
  font-weight: 800;
  color: #111;
  letter-spacing: -0.02em;
  margin-bottom: 12px;
`;

export const SuccessDesc = styled.p`
  font-size: 14px;
  color: #888;
  line-height: 1.8;
  margin-bottom: 36px;
  word-break: keep-all;
`;

export const SuccessButton = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 52px;
  background-color: #1fbc70;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  border-radius: 12px;
  text-decoration: none;
  transition: background-color 0.2s;

  &:hover {
    background-color: #18a860;
  }
`;
